import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from 'Douleutaras/redux/hooks';
import { sellerProfilesSelectors } from 'Douleutaras/redux/data/seller/sellerProfilesSlice';
import InfoModal from 'Douleutaras/components/InfoModal/InfoModal';
import { ProsInfoModalSlugs } from 'Douleutaras/types';
import SkeletonLoader from 'Douleutaras/components/Loaders/SkeletonLoader';
import { ProgressLine } from 'Douleutaras/components/ProgressLine/ProgressLine';
import { useLocalization } from 'Douleutaras/hooks/localization';

import { ProRating } from './ProRating';
import './ReviewSummary.scss';

export const ReviewSummary = ({positive, negative, username}: {positive: number, negative: number, username: string})  => {
  const { t } = useTranslation();
  const { formatter } = useLocalization();
  const profile = useAppSelector(state => sellerProfilesSelectors.selectByUsername(state, username));
  const { loading, error } = useAppSelector(state => state.sellerProfiles);

  const calculateProgress = (value: number) => {
    return (value > 0) ? ((value / profile?.attributes.sellerFeedbacks) * 100) : 0;
  };

  return (
    <div styleName="reviews-section">
      <div styleName="reviews-section__content">
        <div styleName="rating">
          <div styleName="rating__icon" className="dashicon dashicon-star" />
          <p styleName="rating__info">
            { loading
              ? <SkeletonLoader type="line" width={40} height={20} inLine />
              : <>
                  <span styleName="rating__number">{formatter.number(profile?.attributes.sellerRating)}</span>
                  <span styleName="rating__jobs"> ({profile?.attributes.sellerFeedbacks})</span>
                </>
            }
          </p>
        </div>
        { loading
          ? <>
              <SkeletonLoader type="line" />
              <SkeletonLoader type="line" />
              <SkeletonLoader type="line" />
              <SkeletonLoader type="line" />
            </>
          : <>
            <ProRating aggregates={profile?.attributes.aggregates} isCleaner={profile?.attributes?.cleanerSettings} />
            <ProgressLine percentage={calculateProgress(positive)}
                          value={positive}
                          caption={t('T.PROS-PROFILE.REVIEW.POSITIVE')}
                          key={`positive-${positive}`} />
            <ProgressLine percentage={calculateProgress(negative)}
                          value={negative}
                          caption={t('T.PROS-PROFILE.REVIEW.NEGATIVE')}
                          key={`negative-${negative}`} isRed />
            </>
        }
      </div>
      <div styleName="footer">
          <div styleName="footer__text">
            {t('T.PROS-PROFILE.REVIEW.FOOTER-TEXT')}
            <InfoModal modalSlug={ProsInfoModalSlugs.REVIEW_GUIDELINES} text={t('T.PROS-PROFILE.REVIEW.FOOTER-BUTTON')} hideButton/>
          </div>
      </div>
    </div>
  );
};
